import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
/*
  Writing using Setup stores
  https://pinia.vuejs.org/core-concepts/#Setup-Stores
  export const useCounterStore = defineStore('counter', () => {
  const count = ref(0)
  const name = ref('Eduardo')
  const doubleCount = computed(() => count.value * 2)
  function increment() {
    count.value++
  }

  return { count, name, doubleCount, increment }
})
 */
export const useDefaultsListStore = defineStore("defaultsList", () => {
    const species = ref(null);
    const workTasks = ref(null);
    const homeCenter = ref(null);
    const metromap = ref(null);
    const imagery = ref(null);
    const streetmap = ref(null);
    const attributes = ref(null);
    const defaults = ref(null);
    const attachments = ref(null);
    const crm_statuses = ref(null);
    const crm_close_reasons = ref(null);
    const client = ref(null);
    const project = ref(null);
    const applications_settings = ref(null);
    const works_kpis = ref(null);
    const works_schedule = ref(null);
    const activeStorms = ref(null);

    const updateStoreFields = (obj) => {
        // Check each field in the object and update the corresponding ref in the store if it exists
        if (obj.species !== undefined) species.value = obj.species;
        if (obj.workTasks !== undefined) workTasks.value = obj.workTasks;
        if (obj.homeCenter !== undefined) homeCenter.value = obj.homeCenter;
        if (obj.metromap !== undefined) metromap.value = obj.metromap;
        if (obj.imagery !== undefined) imagery.value = obj.imagery;
        if (obj.streetmap !== undefined) streetmap.value = obj.streetmap;
        if (obj.attributes !== undefined) attributes.value = obj.attributes;
        if (obj.defaults !== undefined) defaults.value = obj.defaults;
        if (obj.attachments !== undefined) attachments.value = obj.attachments;
        if (obj.crm_statuses !== undefined) crm_statuses.value = obj.crm_statuses;
        if (obj.crm_close_reasons !== undefined) crm_close_reasons.value = obj.crm_close_reasons;
        if (obj.client !== undefined) client.value = obj.client;
        if (obj.project !== undefined) project.value = obj.project;
        if (obj.applications_settings !== undefined) applications_settings.value = obj.applications_settings;
        if (obj.works_kpis !== undefined) works_kpis.value = obj.works_kpis;
        if (obj.works_schedule !== undefined) works_schedule.value = obj.works_schedule;
        if (obj.activeStorms !== undefined) activeStorms.value = obj.activeStorms;
    };

    const getDefaultsAsync = async () => {
        const route = useRoute();
        let defaultsUrl = "/api/defaults";

        if (route.query.projectId) {
            defaultsUrl = "/api/defaults?projectId=" + route.query.projectId;
        }
        return axios
            .get(defaultsUrl)
            .then((response) => {
                updateStoreFields(response.data);
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data.redirect);
                    window.location.replace("/home");
                }
            });
    };

    const updateSpeciesList = (newSpeciesList) => {
        species.value = newSpeciesList;
    };

    return {
        species,
        workTasks,
        homeCenter,
        metromap,
        imagery,
        streetmap,
        attributes,
        defaults,
        attachments,
        crm_statuses,
        crm_close_reasons,
        client,
        project,
        applications_settings,
        works_kpis,
        works_schedule,
        activeStorms,
        updateStoreFields,
        getDefaultsAsync,
        updateSpeciesList,
    };
});
